module.exports = __webpack_public_path__ + "img/logos-de-marcas.04958349.jpg";